module.exports = __webpack_public_path__ + "img/small-3.3a2085fc.jpg";